import { snowMu } from "./catalog";

const G = 9.81;
// Profilo binario generico in alluminio EN AW-6063 T6
export const RAIL = { W: 4.5e-6, I: 12e-8, fy: 160e6, gM: 1.1, E: 70e9 };
// Portate indicative per ancoraggio [kN] (verso il basso / sollevamento)
export const HOOK_CAP = {
  tegole: { down: 1.8, up: 2.2 }, lamiera: { down: 1.2, up: 1.5 },
  ardesia: { down: 1.5, up: 1.8 }, altro: { down: 2.5, up: 2.5 },
};
const CP_PITCHED = { F: -1.3, G: -1.0, H: -0.5 };
const CP_FLAT = { F: 1.0, G: 0.8, H: 0.6, I: 0.4 };
const SPANS = [1.6, 1.4, 1.2, 1.0, 0.8, 0.6];
const FRICTION = 0.6;
export const BLOCK_KG = 12.5;
export const ZONES = ["F", "G", "H", "I"];

const qsOf = (project, pitch) => {
  const env = project.env || {};
  if (env.manual || env.qsk == null) return Number(env.snow_load) || 0;
  return snowMu(pitch) * env.qsk;
};

function railCheck(L, qDown, qUp, qSls, trib, cap) {
  const MRd = (RAIL.W * RAIL.fy) / RAIL.gM / 1000;
  const lineD = qDown * trib, lineU = qUp * trib;
  const M = (Math.max(lineD, lineU) * L * L) / 8;
  const defl = (5 * qSls * trib * 1000 * L ** 4) / (384 * RAIL.E * RAIL.I);
  const railUt = M / MRd;
  const deflUt = defl / (L / 150);
  const hookUt = Math.max((1.1 * lineD * L) / cap.down, (1.1 * Math.max(0, lineU) * L) / cap.up);
  return { railUt, deflUt, hookUt, ok: railUt <= 1 && deflUt <= 1 && hookUt <= 1, Rd: 1.1 * lineD * L, Ru: 1.1 * Math.max(0, lineU) * L };
}

function pitchedZone(project, field, zone, m, trib) {
  const qp = Number(project.env?.wind_load) || 0;
  const c = Math.cos((field.pitch * Math.PI) / 180);
  const area = (m.length * m.width) / 1e6;
  const g = (m.weight * G) / 1000 / area + 0.05;
  const s = qsOf(project, field.pitch) * c * c;
  const wD = qp * (field.pitch >= 15 ? 0.5 : 0.2);
  const wU = qp * Math.abs(CP_PITCHED[zone]);
  const qDown = Math.max(1.3 * g * c + 1.5 * s + 0.9 * wD, 1.3 * g * c + 1.5 * wD + 0.75 * s);
  const qUp = 1.5 * wU - 1.0 * g * c;
  const qSls = g * c + s + 0.6 * wD;
  const cap = HOOK_CAP[project.covering] || HOOK_CAP.altro;
  let span = SPANS[SPANS.length - 1], chk = railCheck(span, qDown, qUp, qSls, trib, cap);
  for (const L of SPANS) {
    const r = railCheck(L, qDown, qUp, qSls, trib, cap);
    if (r.ok) { span = L; chk = r; break; }
  }
  return { cp: CP_PITCHED[zone], qDown, qUp, span, ...chk };
}

function flatZone(project, zone, m) {
  const qp = Number(project.env?.wind_load) || 0;
  const tilt = Number(project.modules.tilt) || 10;
  const k = tilt >= 15 ? 1.2 : 1;
  const area = (m.length * m.width) / 1e6;
  const cp = CP_FLAT[zone] * k;
  const cf = tilt >= 15 ? 0.35 : 0.25;
  const U = qp * cp * area, H = qp * cf * area;
  const Gk = ((m.weight + 6) * G) / 1000;
  const Greq = ((1.5 * H) / FRICTION + 1.5 * U) / 0.9;
  const ballastKg = Math.max(0, ((Greq - Gk) * 1000) / G);
  const blocks = Math.ceil(ballastKg / BLOCK_KG);
  return { cp, U, H, ballastKg, blocks, kgm2: (blocks * BLOCK_KG + m.weight + 6) / area, ok: true };
}

export function computeStatics(project, layout) {
  const m = layout.module;
  const trib = layout.dsl / 2;
  const fields = layout.fields.map((f) => {
    const zones = {};
    f.active.forEach((c) => { zones[c.zone] = (zones[c.zone] || 0) + 1; });
    const res = {};
    Object.entries(zones).forEach(([z, n]) => {
      res[z] = { n, ...(layout.flat ? flatZone(project, z, m) : pitchedZone(project, f, z, m, trib)) };
    });
    return { fid: f.roof.id, name: f.roof.name, pitch: f.pitch, e: f.e, qs: qsOf(project, f.pitch), zones: res };
  });
  const ok = fields.every((f) => Object.values(f.zones).every((z) => z.ok));
  return { fields, ok };
}
